import { Link } from 'react-router-dom';
import { Mark, Moderation } from '@shared/assets';
import { Card, IconButton } from '@shared/ui';
import { Avatar } from '@shared/ui/avatar';
import st from './styles.module.scss';

interface Props {
  isSelectionOn: boolean;
  isSelected: boolean;
  fullNameVisitor: string;
  phoneNumber: string;
  isPayed: boolean;
  onSelected: () => void;
  ticketId: string;
}

export const VisitorCard: React.FC<Props> = ({
  isSelectionOn,
  isSelected,
  fullNameVisitor,
  phoneNumber,
  isPayed,
  onSelected,
  ticketId,
}) => {
  return (
    <Card className={st.visitor}>
      {isSelectionOn && (
        <IconButton
          size="small"
          variant={isSelected ? 'active' : 'outlined'}
          className={`${st.item__body} ${isSelected && st.tag__checked}`}
          onClick={onSelected}
        >
          {isSelected && <Mark />}
        </IconButton>
      )}

      {/* <Avatar src={ticket.photo} defaultVariant='primary' /> */}
      <Link to={ticketId} className={st.visitor__content}>
        <div className={st.visitor__shotInfo}>
          <div className={st.visitor__avatar}>
            <Avatar defaultVariant="primary" />
          </div>

          <div className={st.visitor__info}>
            <p className={st.info__name}>{fullNameVisitor}</p>
            <p className={st.info__phone}>{`+ ${phoneNumber}`}</p>
          </div>
        </div>

        {/**Когда будет поле суммы сделать проверку на сумму*/}
        <div className={`${st.costStatus} ${isPayed ? st.payed : st.notPayed}`}>
          <p>{isPayed ? 'Оплачено' : 'Частично оплачено'}</p>
          {!isPayed && (
            <span>
              <Moderation />
            </span>
          )}
        </div>
      </Link>
    </Card>
  );
};
